import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useSEO } from "../lib/seo";
import { Reveal } from "../lib/reveal";
import ProjectCard from "../components/ProjectCard";
import { PROJECT_FILTERS } from "../data/content";

const RealisationsPage = () => {
  useSEO(
    "Réalisations — BÂTI 360 | Rénovation Paris & Île-de-France",
    "Découvrez les chantiers BÂTI 360 : rénovation d'appartements à Paris, couverture zinc, ouvertures de murs porteurs, verrières, terrasses et rénovation énergétique en Île-de-France."
  );
  const [params, setParams] = useSearchParams();
  const active = params.get("cat") || "tous";
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/projects", { params: active === "tous" ? {} : { category: active } })
      .then((res) => setProjects(res.data || []))
      .catch(() => setProjects([]))
      .finally(() => setLoading(false));
  }, [active]);

  return (
    <div className="pt-20 md:pt-24">
      <header className="border-b border-black/10 bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <p className="mb-4 flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.22em] text-bati-sky">
              <span className="h-px w-10 bg-bati-sky" /> Portfolio
            </p>
            <h1 className="font-display text-4xl font-extrabold tracking-tight text-bati-ink sm:text-5xl lg:text-6xl">
              Nos réalisations
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-bati-ink/60">
              Voici les types de chantiers que BÂTI 360 prend en charge à Paris et en Île-de-France. Ces exemples sont illustrés par des visuels temporaires : les photographies de nos réalisations réelles seront intégrées prochainement.
            </p>
          </Reveal>
        </div>
      </header>

      <div className="sticky top-20 z-30 border-b border-black/10 bg-white/95 backdrop-blur-md md:top-24" data-testid="project-filters">
        <div className="mx-auto flex max-w-7xl gap-1 overflow-x-auto px-5 py-3 lg:px-8">
          {PROJECT_FILTERS.map((f) => (
            <button
              key={f.slug}
              data-testid={`filter-btn-${f.slug}`}
              onClick={() => setParams(f.slug === "tous" ? {} : { cat: f.slug })}
              className={`whitespace-nowrap px-4 py-2 text-[12px] font-bold uppercase tracking-[0.1em] transition-colors duration-300 ${
                active === f.slug ? "bg-bati-blue text-white" : "text-bati-ink/60 hover:bg-bati-mist hover:text-bati-blue"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      <section className="bg-white py-14 lg:py-20">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          {loading ? (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="aspect-[4/3] animate-pulse bg-bati-mist" />
              ))}
            </div>
          ) : projects.length === 0 ? (
            <p className="py-20 text-center text-bati-ink/50" data-testid="no-projects-message">
              Aucun projet dans cette catégorie pour le moment.
            </p>
          ) : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="projects-grid">
              {projects.map((p, i) => (
                <Reveal key={p.id} delay={(i % 3) * 0.08}>
                  <ProjectCard project={p} />
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default RealisationsPage;
